import * as types from '../actions/action-types';
import _ from 'lodash';

const initialState = {
  common: {msg:'',show:false},

};

const commonReducer = function(state = initialState, action) {

  switch(action.type) {

    case types.ALERT_WITH_MESSAGE:
      return Object.assign({},state, action.alert);
      case types.ALERT_HIDE:
      return Object.assign({},state, action.alert);
  }

  return state;

}

export default commonReducer;



/** WEBPACK FOOTER **
 ** ./src/client/app/reducers/common-reducer.js
 **/